export const getSubdomainFromRequest = (request: Request): string => {
  return getSubdomain(new URL(request.url).hostname);
};

export const getSubdomain = (host: string): string => {
  return host.split(".")[0];
};
